'use client'

import { useFeatureFlagEnabled } from 'posthog-js/react'

export function usePostHogFeatureFlag(flagKey: string): boolean {
  const enabled = useFeatureFlagEnabled(flagKey)
  return enabled === true
}
